import { render, staticRenderFns } from "./RentalInvoiceIndex.vue?vue&type=template&id=24e0aca1&scoped=true"
import script from "./RentalInvoiceIndex.vue?vue&type=script&lang=js"
export * from "./RentalInvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./RentalInvoiceIndex.vue?vue&type=style&index=0&id=24e0aca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0aca1",
  null
  
)

export default component.exports